@if (!isLoading()) {
  @if (isLoggedIn()) {
    <oui-layout [menu]="menu()" logoUrl="assets/logo_proxee.svg" menuType="internal">
      <oui-header [userName]="userName()" [userMenu]="userMenu"></oui-header>
      <oui-content-layout>
        <router-outlet></router-outlet>
      </oui-content-layout>
    </oui-layout>
  } @else {
    <oui-layout logoUrl="assets/logo_proxee.svg"> </oui-layout>
    <lib-global-error-page errorType="shm"></lib-global-error-page>
  }
} @else {
  <div class="loading-container">
    <oui-loading></oui-loading>
  </div>
}
